
import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import * as lov_info from '../misc/LovInfo';

const widthStyleDataEntry = { "width": "500px" }

export function SearchDropDown({
    col_id,
    searchFunction,
    value,
    onHandleChangeOption,
}:
    {
        col_id: string,
        searchFunction: (column_id: string, newInputValue: string) => Promise<lov_info.LovInfo[]>,
        value: string,
        onHandleChangeOption: (column_id: string, newInputValue: string, label: string | null) => void,
    }

) {
    const [options, setOptions] = React.useState<string[]>([]);
    const [allOptions, setAllOptions] = React.useState<lov_info.LovInfo[]>([]);

    const handleChange = (column_id, evnt) => {
        const newInputValue = evnt.target.value;
        if (newInputValue == null || newInputValue == '') {
            setOptions([]);
            return;
        }

        searchFunction(column_id, newInputValue).then((data) => {
            setAllOptions(data);
            setOptions(data.map((option) => option.label));

        });
    }

    const handleChangeOption = (column_id, newInputLabel, evnt, options) => {
        const option = allOptions.find(option => option.label === newInputLabel);

        if (option == null) {
            return;
        }
        onHandleChangeOption(column_id, newInputLabel, option.value);
    }

    return (
        <>
            <Autocomplete
                id={col_id}
                key={col_id}
                disablePortal
                disableClearable={true}
                style={widthStyleDataEntry}
                options={options}
                value={value}
                noOptionsText={'None found, enter filter to search.'}

                onChange={(event, newInputValue) => {
                    handleChangeOption(col_id, newInputValue, event, options);
                }}

                renderInput={(params) => <TextField {...params}
                    placeholder='Type to search...'
                    onChange={(event) => { handleChange(col_id, event); }}
                />}
            />
        </>
    );
}